import { Fragment } from 'react';

import useClubAthleteRosterFormGrid from './UseClubAthleteRosterFormGrid';

import ClubAthleteRosterFilterForm from './ClubAthleteRosterFilterForm';

import ClubAthleteRosterFormGridLarge from './ClubAthleteRosterFormGridLarge';
import ClubAthleteRosterFormGridSmall from './ClubAthleteRosterFormGridSmall';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import { formatMultipleValuesForDisplay } from '@usas/ui-web/components/table/utils/TableUtils';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const ClubAthleteRosterFormGrid = ({ clubObj, clubAddressObj, clubRosterArray, isLoading, onEditAthlete,
  onSubmitAthleteFilter, onSubmitAthleteSync, onSubmitAthleteTransfer, onErrorCaught = undefined,
  PRACTICE_GROUP_TYPE_ID, SITE_GROUP_TYPE_ID }) => {
  const {
    displayTransferPopup,
    formGridState,
    selectedAthletesState,
    onClearFilterClicked,
    onSyncSelectedClicked,
    onTransferSelectedClicked,
    onTransferPopupConfirmClicked,
    onTransferPopupCancelClicked,
    onUpdateIsSyncSelected,
    onUpdateIsTransferSelected
  } = useClubAthleteRosterFormGrid(clubRosterArray, onSubmitAthleteFilter, onSubmitAthleteSync, onSubmitAthleteTransfer, onErrorCaught);

  return (
    <Fragment>
      <div className="row usas-extra-bottom-margin">
        <div className="col-xs-12">
          <ClubAthleteRosterFilterForm
            clubObj={clubObj}
            clubAddressObj={clubAddressObj}
            clubRosterArray={clubRosterArray}
            athletesToSyncCount={selectedAthletesState.athletesToSync.length}
            athletesToTransferCount={selectedAthletesState.athletesToTransfer.length}
            onSubmitAthleteFilter={onSubmitAthleteFilter}
            onClearAthleteFilter={onClearFilterClicked}
            onSubmitAthleteSync={onSyncSelectedClicked}
            onSubmitAthleteTransfer={onTransferSelectedClicked}
            PRACTICE_GROUP_TYPE_ID={PRACTICE_GROUP_TYPE_ID}
            SITE_GROUP_TYPE_ID={SITE_GROUP_TYPE_ID} />
        </div>
      </div>
      <div className="row usas-extra-top-margin usas-extra-bottom-margin">
        <div className="col-xs-12">
          {isLoading === false
            ? (
              <div className="row">
                <div className="col-xs-12">
                  {clubRosterArray.length > 499
                    ? <p className={global.ErrorMessage}>More than 500 Athletes returned. Please add additional filters to narrow your results.</p>
                    : <p>{clubRosterArray.length === 1 ? `${clubRosterArray.length} Athlete` : `${clubRosterArray.length} Athletes`}</p>
                  }
                </div>
              </div>
            ) : <Fragment><div className="row usas-extra-top-margin usas-extra-bottom-margin"></div></Fragment>
          }
          <ClubAthleteRosterFormGridLarge formGridState={formGridState} isLoading={isLoading} onEditAthlete={onEditAthlete} onUpdateIsSyncSelected={onUpdateIsSyncSelected} onUpdateIsTransferSelected={onUpdateIsTransferSelected} />
          <ClubAthleteRosterFormGridSmall formGridState={formGridState} isLoading={isLoading} onEditAthlete={onEditAthlete} onUpdateIsSyncSelected={onUpdateIsSyncSelected} onUpdateIsTransferSelected={onUpdateIsTransferSelected} />
        </div>
      </div>
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={'Transfer Members?'}
        displayPopUp={displayTransferPopup === true}
        onModalCanceled={onTransferPopupCancelClicked}>
        <div className="row">
          <p className="col-xs-12">
            Are you sure you want to transfer the selected members to Unattached? After transferring, they will appear on your roster with a Pending status until the transfer is approved.
            <br /><br />
            <span style={{ fontSize: 20, color: 'darkgrey' }}>
              {formatMultipleValuesForDisplay(selectedAthletesState.athletesToTransfer, 'name')}
            </span>
          </p>
        </div>
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={onTransferPopupConfirmClicked}>Yes, Transfer</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onTransferPopupCancelClicked}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
    </Fragment>
  );
};

export default ClubAthleteRosterFormGrid;